export const CREATE_PLC_SAFETY_TRIGGER = 'CREATE_PLC_SAFETY_TRIGGER';
export const CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL = 'CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL';
export const CREATE_PLC_SAFETY_TRIGGER_FAILED = 'CREATE_PLC_SAFETY_TRIGGER_FAILED';
